export default "__VITE_ASSET__BB5ydHn4__"